'use client';

import { Banner } from '@curology/ui-components-web/react/Banner';
import React from 'react';

import { type WinbackPromotion } from '@/components/flow/steps/resubscription-checkout/utils/types';
import { useWinback } from '@/components/flow/steps/resubscription-checkout/utils/useWinback';
import { dayjs } from '@/utils/date/dayjs';

export const WinbackPromotionBanner = ({
  promotion,
}: {
  promotion?: WinbackPromotion;
}) => {
  const {
    shouldDisplayWinback,
    discountAmount,
    expirationDisplayDate,
    banner,
  } = useWinback(promotion);

  if (!promotion || !shouldDisplayWinback) {
    return null;
  }

  const now = dayjs();
  const currentDateRange = banner?.schedule.find(({ startDate, endDate }) => {
    const startsAt = startDate ? dayjs(startDate) : undefined;
    const endsAt = endDate ? dayjs(endDate) : undefined;

    const startsBeforeNow = !startsAt || startsAt.isBefore(now);
    const endsAfterNow = !endsAt || endsAt.isAfter(now);

    return startsBeforeNow && endsAfterNow;
  });

  const fallbackContent =
    discountAmount && expirationDisplayDate
      ? `Get $${discountAmount} off your next box when you resubscribe today. Offer ends ${expirationDisplayDate}!`
      : undefined;

  const bannerContent = currentDateRange?.copy ?? fallbackContent;

  if (!bannerContent) {
    return null;
  }

  return (
    <Banner className="cur-text-center cur-bg-surface-brand-accent cur-text-primary">
      <span dangerouslySetInnerHTML={{ __html: bannerContent }}></span>
      <h1>Hello World</h1>
    </Banner>
  );
};
